// US Location Popup with ipapi
class USLocationPopup {
  constructor() {
    this.apiKey = 'fesIY9xvu03QytJHHNU4PLtCIAWzpxFifN7Ov8OSgaKS5tIgC5';
    this.popupShown = false;
    this.init();
  }

  init() {
    console.log('US Popup script loaded');
    
    // Check if user has already made a choice
    if (sessionStorage.getItem('us-popup-choice-made') === 'true') {
      console.log('User already made a choice this session');
      return;
    }
    
    console.log('Starting location check...');
    
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.checkLocation());
    } else {
      this.checkLocation();
    }
  }

  async checkLocation() {
    try {
      console.log('Making API request to ip-api.com...');
      
      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => reject(new Error('API timeout')), 5000);
      });
      
      const fetchPromise = fetch('https://pro.ip-api.com/json/?key=ZrWTIeWwOLSdy8h')
        .then(response => response.json());
      
      const data = await Promise.race([fetchPromise, timeoutPromise]);
      
      console.log('Location data:', data);
      console.log('Country code:', data.countryCode);
      
      if (data.countryCode === 'US') {
        console.log('US visitor detected, showing popup');
        this.showPopup();
      } else {
        console.log('Non-US visitor, popup will not show');
      }
    } catch (error) {
      console.error('Error fetching location data:', error);
      console.log('API failed. Showing popup as fallback to avoid missing US customers.');
      this.showPopup();
    }
  }

  showPopup() {
    if (this.popupShown) return;
    
    console.log('Showing popup...');
    this.popupShown = true;
    
    // Create popup HTML
    const popupHTML = `
      <div id="us-location-popup" class="us-popup-overlay">
        <div class="us-popup-content">
          <div class="us-popup-text">
            <h2>Are you shopping from the United States?</h2>
            <p>Our US store is the only way to ship to a US address.</p>
            <p>Enjoy local shipping rates and returns.</p>
          </div>
          <div class="us-popup-buttons">
            <button class="us-popup-btn button button--full-width button--primary" data-action="usa">
              DEIJI STUDIOS - USA
            </button>
            <button class="us-popup-btn button button--full-width button--primary" data-action="international">
              STAY ON DEIJI STUDIOS - AU / INTERNATIONAL
            </button>
          </div>
        </div>
      </div>
    `;
    
    // Insert popup into DOM
    document.body.insertAdjacentHTML('beforeend', popupHTML);
    
    // Add event listeners
    this.attachEventListeners();
    
    // Show popup with animation
    requestAnimationFrame(() => {
      document.getElementById('us-location-popup').classList.add('active');
      console.log('Popup displayed on screen');
    });
  }

  attachEventListeners() {
    const popup = document.getElementById('us-location-popup');
    const actionButtons = popup.querySelectorAll('[data-action]');
    
    // Action buttons only - users must choose one
    actionButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const action = e.target.dataset.action;
        this.handleAction(action);
      });
    });
  }

  handleAction(action) {
    console.log('Action selected:', action);
    
    // Mark that user has made a choice
    sessionStorage.setItem('us-popup-choice-made', 'true');
    
    if (action === 'usa') {
      // Redirect to US store - update with your actual US store URL
      window.location.href = 'https://us.deijistudios.com';
    } else if (action === 'international') {
      // Redirect to international store - update with your actual international store URL
      window.location.href = 'https://deijistudios.com';
    }
    
    this.closePopup();
  }

  closePopup() {
    const popup = document.getElementById('us-location-popup');
    if (popup) {
      popup.classList.remove('active');
      setTimeout(() => {
        popup.remove();
      }, 300);
    }
  }
}

// Initialize popup when script loads
new USLocationPopup(); // Store Switcher Header Dropdown - Click functionality only

// Store Switcher Header Dropdown - Click functionality only
class StoreSwitcher {
  constructor() {
    this.isOpen = false;
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.attachEventListeners());
    } else {
      this.attachEventListeners();
    }
  }

  attachEventListeners() {
    // Desktop version
    const trigger = document.querySelector('.store-switcher-trigger');
    const dropdown = document.querySelector('.store-switcher-dropdown');
    const switcher = document.querySelector('#store-switcher');

    // Mobile version
    const mobileTrigger = document.querySelector('.mobile-store-switcher-trigger');
    const mobileDropdown = document.querySelector('.mobile-store-switcher-dropdown');
    const mobileSwitcher = document.querySelector('#mobile-store-switcher');

    // Desktop event listeners
    if (trigger && dropdown && switcher) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleDropdown();
      });
    }

    // Mobile event listeners
    if (mobileTrigger && mobileDropdown && mobileSwitcher) {
      mobileTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.toggleMobileDropdown();
      });
      
      // Prevent clicks anywhere in the mobile switcher from closing drawer
      mobileSwitcher.addEventListener('click', (e) => {
        e.stopPropagation();
        e.stopImmediatePropagation();
      });
    }

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (switcher && !switcher.contains(e.target)) {
        this.closeDropdown();
      }
      if (mobileSwitcher && !mobileSwitcher.contains(e.target)) {
        this.closeMobileDropdown();
      }
    });

    // Close dropdown on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeDropdown();
        this.closeMobileDropdown();
        if (trigger) trigger.focus();
        if (mobileTrigger) mobileTrigger.focus();
      }
    });
  }

  toggleDropdown() {
    if (this.isOpen) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    this.isOpen = true;
    
    const trigger = document.querySelector('.store-switcher-trigger');
    const dropdown = document.querySelector('.store-switcher-dropdown');
    const switcher = document.querySelector('#store-switcher');
    
    if (trigger && dropdown && switcher) {
      trigger.setAttribute('aria-expanded', 'true');
      switcher.classList.add('open');
      dropdown.classList.add('open');
    }
  }

  closeDropdown() {
    this.isOpen = false;
    
    const trigger = document.querySelector('.store-switcher-trigger');
    const dropdown = document.querySelector('.store-switcher-dropdown');
    const switcher = document.querySelector('#store-switcher');
    
    if (trigger && dropdown && switcher) {
      trigger.setAttribute('aria-expanded', 'false');
      switcher.classList.remove('open');
      dropdown.classList.remove('open');
    }
  }

  toggleMobileDropdown() {
    if (this.isOpen) {
      this.closeMobileDropdown();
    } else {
      this.openMobileDropdown();
    }
  }

  openMobileDropdown() {
    this.isOpen = true;
    
    const trigger = document.querySelector('.mobile-store-switcher-trigger');
    const dropdown = document.querySelector('.mobile-store-switcher-dropdown');
    const switcher = document.querySelector('#mobile-store-switcher');
    
    if (trigger && dropdown && switcher) {
      trigger.setAttribute('aria-expanded', 'true');
      switcher.classList.add('open');
      dropdown.classList.add('open');
    }
  }

  closeMobileDropdown() {
    this.isOpen = false;
    
    const trigger = document.querySelector('.mobile-store-switcher-trigger');
    const dropdown = document.querySelector('.mobile-store-switcher-dropdown');
    const switcher = document.querySelector('#mobile-store-switcher');
    
    if (trigger && dropdown && switcher) {
      trigger.setAttribute('aria-expanded', 'false');
      switcher.classList.remove('open');
      dropdown.classList.remove('open');
    }
  }
}

// Initialize store switcher when script loads
new StoreSwitcher(); 